import { useState } from 'react';
import PropTypes from 'prop-types';
import { ClickAwayListener } from '@mui/material';
import PlezzelButton from './PlezzelButton';
import PlezzelDialogue from './PlezzelDialogue';

const PlezzelDropdown = (props) => {
    const [open, setOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const handleClickEvent = (event) => {
        setOpen(!open);
        setAnchorEl(event?.currentTarget || event?.target);
    };

    const onClickAway = () => {
        setOpen(false);
    };
    return (
        <ClickAwayListener onClickAway={onClickAway} >
            <div>
                <PlezzelButton
                    propertyId={props.propertyId}
                    handleClickEvent={handleClickEvent}
                />
                <PlezzelDialogue
                    open={open}
                    anchorEl={anchorEl}
                />
            </div>
        </ClickAwayListener>
    );
};

PlezzelDropdown.propTypes = {
    propertyId: PropTypes.string,
};
export default PlezzelDropdown;